'use client';
import React from 'react';
import { motion } from 'framer-motion';
import Link from 'next/link';

const reasons = [
    {
        title: "Scale Without Compromise",
        desc: "Whether you need 5,000 or 5 million labels, our production lines maintain identical quality profiles, ensuring your brand looks consistent globally.",
        icon: "⚖️"
    },
    {
        title: "Reduced Turnaround Times",
        desc: "With automated job setup and ultra-high-speed printing, we slash production cycles, helping you get products to market faster than ever before.",
        icon: "⚡"
    },
    {
        title: "Compliance & Standards",
        desc: "Our facility operates under strict hygiene and quality protocols, compliant with FMCG, Pharma, and Food & Beverage industry requirements.",
        icon: "🛡️"
    },
    {
        title: "Premium Finish Options",
        desc: "Our dual-finishing stations allow for multiple special effects in a single pass, providing sophisticated textures that resonate with luxury consumers.",
        icon: "✨"
    }
];

const WhyInfrastructure = () => {
    return (
        <section className="bg-white py-24 relative overflow-hidden">
            {/* Background pattern - Light */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#000_1px,transparent_1px)] [background-size:40px_40px]" />
            </div>

            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-display font-bold text-[#09172e] mb-6">
                        Why Our Infrastructure Matters
                    </h2>
                    <div className="w-24 h-1 bg-[#2e8b8d] mx-auto mb-8" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    {reasons.map((reason, index) => (
                        <motion.div
                            key={index}
                            className="text-center group"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <div className="w-20 h-20 bg-gray-50 border border-gray-200 rounded-2xl flex items-center justify-center text-4xl mb-8 mx-auto group-hover:bg-[#2e8b8d]/10 group-hover:border-[#2e8b8d]/30 transition-all duration-300">
                                {reason.icon}
                            </div>
                            <h3 className="text-xl font-display font-bold text-[#09172e] mb-4">
                                {reason.title}
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed">
                                {reason.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>


            </div>
        </section>
    );
};

export default WhyInfrastructure;
